/* ============================================================
   HOT HITZ LA — theme.js
   Site-wide behaviour. Every block is guarded so it no-ops on
   pages where the target elements don't exist.
   ============================================================ */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = (window.BBLA && window.BBLA.moneyFormat) || '${{amount}}';

  /* ---------- money formatter (Shopify-style) ---------- */
  function formatMoney(cents){
    cents = (typeof cents === 'string') ? cents.replace('.','') : cents;
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n,d){ n=Math.round(n); return n; }
    var amount = (cents/100).toFixed(2);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    value = dollars + '.' + parts[1];
    return money.replace(placeholderRegex, value);
  }

  /* ---------- toast ---------- */
  var toast=document.getElementById('toast'),
      tTitle=document.getElementById('toastTitle'),
      tMsg=document.getElementById('toastMsg'), tTimer;
  function showToast(title,msg){
    if(!toast) return;
    if(tTitle) tTitle.textContent=title;
    if(tMsg) tMsg.textContent=msg;
    toast.classList.add('show');
    clearTimeout(tTimer);
    tTimer=setTimeout(function(){toast.classList.remove('show');},3400);
  }
  window.BBLAToast = showToast;

  /* ---------- ticker ---------- */
  (function(){
    var el=document.getElementById('ticker');
    if(!el) return;
    var raw=(el.getAttribute('data-items')||'New Drops Weekly,Pokémon,One Piece,Funko Pops,Sealed Product,Hot Hitz LA');
    var items=raw.split('|').map(function(s){return s.trim();}).filter(Boolean);
    var html='';
    for(var r=0;r<2;r++){
      for(var i=0;i<items.length;i++){html+='<span>'+items[i]+'</span><span class="dot">·</span>';}
    }
    el.innerHTML=html;
  })();

  /* ---------- nav scroll state ---------- */
  (function(){
    var nav=document.getElementById('nav');
    if(!nav) return;
    function onScroll(){ if(window.scrollY>40) nav.classList.add('solid'); else nav.classList.remove('solid'); }
    onScroll();
    window.addEventListener('scroll',onScroll,{passive:true});
  })();

  /* ---------- mobile menu ---------- */
  (function(){
    var burger=document.getElementById('hamburger'), mm=document.getElementById('mobileMenu');
    if(!burger || !mm) return;
    burger.addEventListener('click',function(){
      burger.classList.toggle('open');
      mm.classList.toggle('open');
      document.body.style.overflow=mm.classList.contains('open')?'hidden':'';
    });
    mm.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click',function(){
        burger.classList.remove('open');mm.classList.remove('open');document.body.style.overflow='';
      });
    });
  })();

  /* ---------- reveal observer ---------- */
  (function(){
    var els=document.querySelectorAll('.reveal');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.16,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
  })();

  /* ---------- progress bars fill on reveal ---------- */
  (function(){
    var els=document.querySelectorAll('.pbar[data-fill]');
    if(!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function(el){var i=el.querySelector('i'); if(i) i.style.width=el.getAttribute('data-fill')+'%';});
      return;
    }
    var pio=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ var i=e.target.querySelector('i'); if(i) i.style.width=e.target.getAttribute('data-fill')+'%'; pio.unobserve(e.target); } });
    },{threshold:.4});
    els.forEach(function(el){pio.observe(el);});
  })();

  /* ---------- count up ---------- */
  (function(){
    var els=document.querySelectorAll('.count');
    if(!els.length) return;
    function fmt(n,comma){ return comma? n.toLocaleString('en-US'): String(n); }
    if(!('IntersectionObserver' in window)){ els.forEach(function(el){el.textContent=fmt(+el.getAttribute('data-to'),el.getAttribute('data-comma'));}); return; }
    var cio=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        var el=e.target, to=+el.getAttribute('data-to'), comma=el.getAttribute('data-comma'), dur=1500, t0=null;
        if(reduce){ el.textContent=fmt(to,comma); cio.unobserve(el); return; }
        function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1); var ease=1-Math.pow(1-p,3);
          el.textContent=fmt(Math.round(to*ease),comma); if(p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step); cio.unobserve(el);
      });
    },{threshold:.6});
    els.forEach(function(el){cio.observe(el);});
  })();

  /* ---------- live widget spot grid (homepage marketing element) ---------- */
  (function(){
    var grid=document.getElementById('spots');
    if(!grid) return;
    var total=10, taken=[2,5,7], mine=[],
        left=document.getElementById('spotsLeft'), bar=document.getElementById('wbar');
    var teams=['NYY','LAD','BOS','CHC','ATL','HOU','SD','PHI','SF','NYM'];
    function render(){
      grid.innerHTML='';
      for(var i=0;i<total;i++){
        var d=document.createElement('div');
        var isTaken=taken.indexOf(i)>-1, isMine=mine.indexOf(i)>-1;
        d.className='spot '+(isMine?'mine taken':(isTaken?'taken':'open'));
        d.textContent=teams[i];
        d.setAttribute('data-i',i);
        if(!isTaken || isMine){ d.addEventListener('click',toggle); }
        grid.appendChild(d);
      }
      var filled=taken.length+mine.length;
      if(left) left.textContent=(total-filled);
      if(bar) bar.style.width=Math.round(filled/total*100)+'%';
    }
    function toggle(){
      var i=+this.getAttribute('data-i'), idx=mine.indexOf(i);
      if(idx>-1){ mine.splice(idx,1); }
      else{ if(taken.length+mine.length>=total){return;} mine.push(i); showToast('Spot picked · '+teams[i], 'Hit "Grab a Spot" to head to checkout.'); }
      render();
    }
    render();
    var joinBtn=document.getElementById('joinBtn');
    if(joinBtn){
      joinBtn.addEventListener('click',function(e){
        // If it links to a product/collection, let it navigate; otherwise nudge.
        if(joinBtn.tagName==='A' && joinBtn.getAttribute('href') && joinBtn.getAttribute('href')!=='#') return;
        e.preventDefault();
        if(mine.length===0){ showToast('Pick a team first','Click an open tile in the grid above.'); return; }
        var names=mine.map(function(i){return teams[i];}).join(', ');
        showToast(mine.length+' spot'+(mine.length>1?'s':'')+' picked', names+' · continue to the break.');
      });
    }
  })();

  /* ---------- countdown ---------- */
  (function(){
    var el=document.getElementById('cd');
    if(!el) return;
    var target=new Date(); target.setHours(target.getHours()+2, target.getMinutes(), 0, 0);
    function tick(){
      var diff=target-new Date();
      if(diff<=0){ target.setHours(target.getHours()+2); diff=target-new Date(); }
      var h=Math.floor(diff/3.6e6), m=Math.floor(diff%3.6e6/6e4), s=Math.floor(diff%6e4/1e3);
      function p(x){return (x<10?'0':'')+x;}
      el.textContent=p(h)+':'+p(m)+':'+p(s);
    }
    tick(); setInterval(tick,1000);
  })();

  /* ---------- particles ---------- */
  (function(){
    var c=document.getElementById('particles');
    if(!c || reduce) return;
    var ctx=c.getContext('2d'), parts=[], DPR=Math.min(window.devicePixelRatio||1,2);
    function size(){ c.width=c.offsetWidth*DPR; c.height=c.offsetHeight*DPR; }
    function init(){
      size(); parts=[];
      var n=Math.round(c.offsetWidth/16);
      for(var i=0;i<n;i++){ parts.push({x:Math.random()*c.width,y:Math.random()*c.height,r:(Math.random()*1.6+0.4)*DPR,vy:-(Math.random()*0.25+0.05)*DPR,vx:(Math.random()-0.5)*0.12*DPR,a:Math.random()*0.5+0.1,tw:Math.random()*0.02+0.005,gold:Math.random()>0.4}); }
    }
    function loop(){
      ctx.clearRect(0,0,c.width,c.height);
      for(var i=0;i<parts.length;i++){ var p=parts[i];
        p.y+=p.vy; p.x+=p.vx; p.a+=p.tw; var aa=0.12+Math.abs(Math.sin(p.a))*0.4;
        if(p.y<-10){ p.y=c.height+10; p.x=Math.random()*c.width; }
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,7);
        ctx.fillStyle=(p.gold?'245,200,48':'31,155,181'); ctx.fillStyle='rgba('+ctx.fillStyle+','+aa+')';
        ctx.shadowBlur=6*DPR; ctx.shadowColor='rgba(245,200,48,'+(aa*0.5)+')';
        ctx.fill();
      }
      requestAnimationFrame(loop);
    }
    init(); loop();
    var rt; window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(init,200);});
  })();

  /* ---------- hero falling-cards parallax + content exit ---------- */
  (function(){
    var hero=document.querySelector('.hero');
    if(!hero || reduce) return;
    var content=hero.querySelector('.wrap'), fall=document.getElementById('fall');
    if(!content) return;
    var cx=0, cy=0, raf=null;
    function apply(){
      var sc=window.scrollY, h=hero.offsetHeight;
      var p=Math.min(sc/(h*0.85),1);
      content.style.transform='translateY('+(sc*0.18).toFixed(1)+'px)';
      content.style.opacity=(1-p*0.92).toFixed(3);
      if(fall) fall.style.transform='translate3d('+(cx*20).toFixed(1)+'px,'+(cy*14).toFixed(1)+'px,0)';
      raf=null;
    }
    function req(){ if(!raf) raf=requestAnimationFrame(apply); }
    window.addEventListener('scroll',req,{passive:true});
    hero.addEventListener('mousemove',function(e){
      var r=hero.getBoundingClientRect();
      cx=(e.clientX-r.left)/r.width-0.5; cy=(e.clientY-r.top)/r.height-0.5; req();
    });
    hero.addEventListener('mouseleave',function(){cx=0;cy=0;req();});
    apply();
  })();

  /* ---------- update cart count in header ---------- */
  function refreshCartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent=cart.item_count;
          el.setAttribute('data-empty', cart.item_count===0 ? 'true':'false');
        });
      }).catch(function(){});
  }

  /* ---------- AJAX add-to-cart (product cards w/ data-add) ---------- */
  (function(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-add]');
      if(!btn) return;
      var vid=btn.getAttribute('data-variant-id');
      if(!vid) return;
      e.preventDefault();
      if(btn.hasAttribute('disabled')) return;
      var label=btn.getAttribute('data-title')||'Item';
      btn.setAttribute('disabled','');
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})
      }).then(function(r){return r.json();})
        .then(function(){ showToast('Added to cart', label+' · reserved.'); refreshCartCount(); })
        .catch(function(){ showToast('Hmm — try again', 'Could not add that item.'); })
        .finally(function(){ btn.removeAttribute('disabled'); });
    });
  })();

  /* ---------- product page: variant picker, gallery, qty ---------- */
  (function(){
    var form=document.querySelector('[data-product-form]');
    if(!form) return;
    var dataEl=document.getElementById('product-json');
    var product=null;
    try{ product=JSON.parse(dataEl.textContent); }catch(err){ return; }

    var idInput=form.querySelector('[name="id"]');
    var priceNow=document.querySelector('[data-price-now]');
    var priceWas=document.querySelector('[data-price-was]');
    var priceSave=document.querySelector('[data-price-save]');
    var addBtn=form.querySelector('[data-add-main]');
    var optionInputs=form.querySelectorAll('[data-opt]');

    function currentOptions(){
      var opts=[];
      optionInputs.forEach(function(inp){
        if(inp.checked || inp.tagName==='SELECT'){ opts[+inp.getAttribute('data-opt-index')]=inp.value; }
      });
      return opts;
    }
    function findVariant(){
      var opts=currentOptions();
      return product.variants.find(function(v){
        return v.options.every(function(o,i){ return opts[i]===undefined || o===opts[i]; });
      });
    }
    function update(){
      var v=findVariant();
      if(!v) return;
      idInput.value=v.id;
      if(priceNow) priceNow.textContent=formatMoney(v.price);
      if(priceWas){
        if(v.compare_at_price && v.compare_at_price>v.price){ priceWas.style.display=''; priceWas.textContent=formatMoney(v.compare_at_price); if(priceSave){priceSave.style.display='';} }
        else { priceWas.style.display='none'; if(priceSave) priceSave.style.display='none'; }
      }
      if(addBtn){
        if(v.available){ addBtn.removeAttribute('disabled'); addBtn.querySelector('span').textContent='Add to Cart'; }
        else { addBtn.setAttribute('disabled',''); addBtn.querySelector('span').textContent='Sold Out'; }
      }
    }
    optionInputs.forEach(function(inp){ inp.addEventListener('change',update); });
    update();

    // qty stepper
    var qtyInput=form.querySelector('[data-qty]');
    form.querySelectorAll('[data-qty-step]').forEach(function(b){
      b.addEventListener('click',function(){
        var step=+b.getAttribute('data-qty-step');
        var val=Math.max(1,(parseInt(qtyInput.value,10)||1)+step);
        qtyInput.value=val;
      });
    });

    // AJAX add for main product form
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var v=findVariant();
      if(!v || !v.available) return;
      addBtn.setAttribute('disabled','');
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:v.id, quantity:parseInt(qtyInput?qtyInput.value:1,10)||1}]})
      }).then(function(r){return r.json();})
        .then(function(){ showToast('Added to cart', product.title+' · reserved.'); refreshCartCount(); })
        .catch(function(){ showToast('Hmm — try again','Could not add that item.'); })
        .finally(function(){ addBtn.removeAttribute('disabled'); });
    });

    // gallery thumbs
    var mainImg=document.querySelector('[data-main-img]');
    document.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        if(mainImg) mainImg.src=t.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('active');});
        t.classList.add('active');
      });
    });
  })();

  /* ---------- accordion ---------- */
  (function(){
    var heads=document.querySelectorAll('.acc__head');
    if(!heads.length) return;
    heads.forEach(function(h){
      h.addEventListener('click',function(){
        var item=h.closest('.acc__item'); var body=item.querySelector('.acc__body');
        var open=item.classList.toggle('open');
        body.style.maxHeight=open?(body.querySelector('.inner').offsetHeight+'px'):'0px';
      });
    });
    var first=document.querySelector('.acc__item');
    if(first){ first.classList.add('open'); var b=first.querySelector('.acc__body'); if(b) b.style.maxHeight=b.querySelector('.inner').offsetHeight+'px'; }
  })();

  /* ---------- Buy It Now (add then go to checkout) ---------- */
  (function(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-buy-now]');
      if(!btn) return;
      e.preventDefault();
      var form=btn.closest('[data-product-form]'); if(!form) return;
      var id=form.querySelector('[name="id"]').value;
      var q=form.querySelector('[data-qty]');
      btn.setAttribute('disabled','');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:parseInt(q?q.value:1,10)||1}]})})
        .then(function(){ window.location.href='/checkout'; })
        .catch(function(){ btn.removeAttribute('disabled'); showToast('Hmm — try again','Could not start checkout.'); });
    });
  })();

  refreshCartCount();
})();
